import { MultiSelectDataDropdown } from "capitalrx-components-2.0/lib/forms";
import { Icd10 } from "capitalrx-types";

import { getApiBaseUrl } from "@/api";
import { useCustomDataSource } from "@/api-hooks";
import { FormElementBaseProps } from "@/api/interfaces";


export const DiagnosisCodeMultiSelect = ({
  name = "diagnosis_codes",
  label = "Diagnosis Code(s)",
  required = false,
  disabled = false,
}: FormElementBaseProps) => {
  const apiBaseUrl = getApiBaseUrl();

  const dataSource = useCustomDataSource<Icd10>({
    url: `${apiBaseUrl}/pa_icd10/list`,
    idProvider: (row) => row.code,
    options: {
      filter: {
        code_or_description: "",
      },
      idFilterName: "code_or_description",
      pageSize: 10,
    },
    searchLength: 0,
  });

  return (
    <MultiSelectDataDropdown.Field
      testId="test__icd_10"
      dataSource={dataSource}
      optionLabelProvider={(row) => `${row?.code} ${row?.long_description}`}
      label={label}
      name={name}
      searchField="code_or_description"
      required={required}
      disabled={disabled}
    />
  );
};
